/* eslint-disable no-unused-vars */
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const ACCOUNTING_OTHER_ACTION_TYPE = createNamedActions('accountingOther', {
  CREATE_ADVANCE_PROCESS: 'CREATE_ADVANCE_PROCESS',
  CREATE_ADVANCE_UPLOAD: 'CREATE_ADVANCE_UPLOAD',
  CREATE_PURCHASE_ADVICE_PROCESS: 'CREATE_PURCHASE_ADVICE_PROCESS',
  CREATE_PURCHASE_ADVICE_UPLOAD: 'CREATE_PURCHASE_ADVICE_UPLOAD',
  CREATE_PURCHASED_LOANS_PROCESS: 'CREATE_PURCHASED_LOANS_PROCESS',
  CREATE_PURCHASED_LOANS_UPLOAD: 'CREATE_PURCHASED_LOANS_UPLOAD',
});

export const createAdvanceProcessAction = catchAsyncActionError(
  ({ formData, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createAdvanceProcess({ formData, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_ADVANCE_PROCESS,
      //   payload: data,
      // });
    },
);

export const createAdvanceUploadAction = catchAsyncActionError(
  ({ list: body, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createAdvanceUpload({ body, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_ADVANCE_UPLOAD,
      //   payload: data,
      // });
    },
);

export const createPurchaseAdviceProcessAction = catchAsyncActionError(
  ({ formData, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createPurchaseAdviceProcess({ formData, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_PURCHASE_ADVICE_PROCESS,
      //   payload: data,
      // });
    },
);

export const createPurchaseAdviceUploadAction = catchAsyncActionError(
  ({ list: body, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createPurchaseAdviceUpload({ body, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_PURCHASE_ADVICE_UPLOAD,
      //   payload: data,
      // });
    },
);

export const createPurchasedLoansProcessAction = catchAsyncActionError(
  ({ formData, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createPurchasedLoansProcess({ formData, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_PURCHASED_LOANS_PROCESS,
      //   payload: data,
      // });
    },
);

export const createPurchasedLoansUploadAction = catchAsyncActionError(
  ({ list: body, ...params }) =>
    async dispatch => {
      // const { data } = await accountingApi.createPurchasedLoansUpload({ body, ...params });
      // return dispatch({
      //   type: ACCOUNTING_OTHER_ACTION_TYPE.CREATE_PURCHASED_LOANS_UPLOAD,
      //   payload: data,
      // });
    },
);
